"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopComponent = void 0;
const utils_1 = require("../../utils/utils");
const base_component_1 = require("../../components/base-component");
const dom_1 = require("../../utils/dom");
const ELEMENTS = [
    'ShopProducts',
    'ShopProductCount',
    'ShopSortList',
    'ShopActiveFilters',
];
const PRELOADER_SELECTOR = '#ShopProductsOverlay';
const MOBILE_FILTER_SELECTOR = '#SidebarFiltersMobile';
const DESKTOP_FILTER_SELECTOR = '#SidebarFiltersDesktop';
const SHOP_COLLECTION_FILTER_SELECTOR = '#ShopCollectionFilter';
class ShopComponent extends base_component_1.BaseComponent {
    searchParamsInitial;
    searchParamsPrev;
    sortQuery = '';
    filterQuery = '';
    constructor() {
        super();
        this.searchParamsInitial = window.location.search.slice(1);
        this.searchParamsPrev = this.searchParamsInitial;
    }
    mountComponent() {
        this.addListener(window, 'popstate', this.handleHistoryChange);
    }
    handleHistoryChange = ({ state: { searchParams } }) => {
        const newSearchParams = searchParams || this.searchParamsInitial;
        if (newSearchParams !== this.searchParamsPrev) {
            this.updateBySearchParams(newSearchParams);
        }
    };
    formatParams(searchParams) {
        this.searchParamsPrev = searchParams;
        return `${this.dataset.baseParams ? `${this.dataset.baseParams}` : ''}${searchParams}`;
    }
    updateBySearchParams(searchParams) {
        const baseUrl = window.location.pathname;
        const params = `${this.formatParams(searchParams ? `${searchParams}` : '')}`;
        const url = baseUrl + '?' + params;
        const { firstTarget } = (0, utils_1.getTargets)(this);
        firstTarget?.focus();
        this.updateURL(searchParams, url);
        this.updateShop(url);
        this.updateFilters(url);
    }
    async getFromUrl(url) {
        const preloaderElement = (0, utils_1.$el)(PRELOADER_SELECTOR, this);
        preloaderElement.classList.remove('hidden');
        return fetch(url)
            .then(response => response.text())
            .then(responseText => {
            preloaderElement.classList.add('hidden');
            return (0, dom_1.parseHTML)(responseText);
        })
            .catch(() => console.log('Error in shop component'));
    }
    // initVideo = (lazyVideo: HTMLElement) => {
    //   const parentNode = lazyVideo.parentNode
    //   const withAutoplay = lazyVideo.hasAttribute('with-autoplay')
    //   if (!parentNode) {
    //     return
    //   }
    //   const video = lazyVideo.querySelector('video') as HTMLVideoElement
    //   video.load()
    //   const handleTouch = () => {
    //     if (video.paused && withAutoplay) {
    //       video.load()
    //       video.play()
    //     }
    //     this.removeListener(window, 'touchstart', handleTouch)
    //   }
    //   const handleCanPlay = () => {
    //     parentNode.replaceChild(video, lazyVideo)
    //     if (withAutoplay) {
    //       video.play()
    //     }
    //     this.removeListener(video, 'canplaythrough', handleCanPlay)
    //   }
    //   this.addListener(video, 'canplaythrough', handleCanPlay)
    //   this.addListener(window, 'touchstart', handleTouch)
    // }
    // initResponsiveImages = () => {
    //   const responsiveImages = document.querySelectorAll("[data-src-desktop]");
    //   responsiveImages.forEach((img: HTMLImageElement) => {
    //     const srcDesktop = img.getAttribute("data-src-desktop");
    //     const srcMobile = img.getAttribute("data-src-mobile");
    //     const src = window.innerWidth > 768 ? srcDesktop : srcMobile;
    //     img.src = src;
    //     img.setAttribute("data-loaded", "true");
    //   });
    // };
    updateShop(url) {
        this.getFromUrl(url).then(html => {
            ELEMENTS.forEach(elementId => {
                const element = (0, utils_1.$el)(`#${elementId}`);
                const newElement = (0, utils_1.$el)(`#${elementId}`, html);
                (0, dom_1.replaceNodeChildren)(element, newElement);
                // const elementAfterReplace = $el(`#${elementId}`);
                // const videos = $list('lazy-video', elementAfterReplace);
                // videos.forEach(video => {
                //   this.initVideo(video);
                // })
                // this.initResponsiveImages();
                // window.addEventListener("resize", this.initResponsiveImages);
            });
        });
    }
    updateFilters(url) {
        const filters = (0, utils_1.$list)(`${MOBILE_FILTER_SELECTOR}, ${DESKTOP_FILTER_SELECTOR}, ${SHOP_COLLECTION_FILTER_SELECTOR}`);
        filters.forEach(filter => {
            filter.preloader.classList.remove('hidden');
        });
        this.getFromUrl(url).then(html => {
            filters.forEach(filter => {
                //@ts-expect-error
                filter.updateHTML(html);
                filter.preloader.classList.add('hidden');
            });
            this.emit('filtersUpdated', {});
        });
    }
    updateURL(searchParams, url) {
        history.pushState({ searchParams }, '', url);
    }
    reset() {
        this.sortQuery = '';
        this.filterQuery = '';
    }
}
exports.ShopComponent = ShopComponent;
